import InfoIcon from '@mui/icons-material/Info';
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import { exportFactoringCreditLine } from 'lib/api/creditLine';
import CustomButton from 'lib/designSystem/Button';
import DialogTitle from 'lib/designSystem/Title/DialogTitle';
import { errorHandler } from 'lib/functions/errors';
import React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

const EXPORT_OPTIONS = {
  'Línea de crédito': 'creditLineMetadata',
  'Evaluación de riesgos': 'creditLineEvaluation',
  Datahub: 'datahub',
};

type Props = {
  openExportDialog: boolean;
  setOpenExportDialog: (open: boolean) => void;
  openRequest: { id: number };
};

const ExportDialog: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { openExportDialog, setOpenExportDialog, openRequest } = props;
  const [loading, setLoading] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState<Set<string>>(
    new Set(Object.values(EXPORT_OPTIONS)),
  );

  const handleToggleOption = (optionValue: string) => {
    setSelectedOptions((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(optionValue)) {
        newSet.delete(optionValue);
      } else {
        newSet.add(optionValue);
      }
      return newSet;
    });
  };

  const exportCreditLine = async () => {
    try {
      setLoading(true);
      const url = new URLSearchParams();
      Array.from(selectedOptions).forEach((option) => {
        url.append('sections', option);
      });
      const query = url.toString();
      const file = await exportFactoringCreditLine(
        dispatch,
        openRequest.id,
        query,
      );
      if (!file) {
        alert('No se pudo generar el archivo');
        return;
      }
      const fileUrl = URL.createObjectURL(file);
      window.open(fileUrl, '_blank');
      setLoading(false);
    } catch (error) {
      errorHandler(dispatch, error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Dialog open={openExportDialog} onClose={() => setOpenExportDialog(false)}>
      <DialogTitle
        title="Reporte de Línea de crédito"
        onClose={() => setOpenExportDialog(false)}
        icon={<InfoIcon color="primary" />}
        color="primary"
      />
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Selecciona qué secciones deseas incluir en el reporte:
        </Typography>
        <Grid container spacing={2}>
          {Object.entries(EXPORT_OPTIONS).map(([label, value]) => (
            <Grid item xs={12} sm={6} key={value}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedOptions.has(value)}
                    onChange={() => handleToggleOption(value)}
                    color="primary"
                    size="small"
                  />
                }
                label={label}
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '0.875rem',
                  },
                }}
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>

      <DialogActions>
        <CustomButton
          onClick={() => setOpenExportDialog(false)}
          color="secondary"
        >
          Cancelar
        </CustomButton>
        <CustomButton
          onClick={() => exportCreditLine()}
          disabled={selectedOptions.size === 0 || loading}
          loading={loading}
        >
          Exportar Reporte
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default ExportDialog;
